export default "__VITE_ASSET__Cy6Aa_P8__";